import { render, staticRenderFns } from "./AlertsItem.vue?vue&type=template&id=c2cc08f4&scoped=true"
import script from "./AlertsItem.vue?vue&type=script&lang=js"
export * from "./AlertsItem.vue?vue&type=script&lang=js"
import style0 from "./AlertsItem.vue?vue&type=style&index=0&id=c2cc08f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cc08f4",
  null
  
)

export default component.exports